export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-sidebar-footer/index.ts